<template>
  <div class="row">
    <div class="col">
      <h2 class="titre">Formulaire Billet - Ici on carte</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col lbl">
          <label>Vague :</label>
        </div>
        <div class="col txt">
          <p v-if="!nomVague"> ... </p>
          <p v-else> {{ nomVague }} </p>
        </div>
      </div>
    </div>
    <div class="col"/>
    <div class="col"/>
  </div>
  <div class="row pt-2">
    <div class="col">
      <div v-if="isSauvegardeEnCours">
        <vue-loaders  name="ball-beat" class = "justify-center"></vue-loaders>
      </div>
      <div v-else>
        <Button label="Sauvegarder" @click="sauvegarder"/>
      </div>
    </div>
    <div class="col">
      <Button label="Imprimer" @click="imprimer"/>
    </div>
    <div class="col">
      <Button label="Annuler" @click="annuler"/>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <DataTable class="p-datatable-sm" :value="billets" :resizableColumns="true" columnResizeMode="fit"
                  :reorderableColumns="true"
                  selectionMode="single" dataKey="cle"
                  :paginator="true" :rows="100"
                  paginatorPosition="both"
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  :rowsPerPageOptions="[10,30,100]"
                  currentPageReportTemplate="Afficher {first} à {last} sur {totalRecords} billets">
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column field="numeroCardex" header="Numéro Cardex" :sortable="true"></Column>
        <Column field="nom" header="Nom loterie" :sortable="true"></Column>
        <Column field="valeur" header="Valeur"
                :sortable="true"></Column>
        <Column field="numeroControle" header="Numéro contrôle"
                :sortable="true"></Column>
        <Column field="consolidationStatutAfficher" header="Statut du billet" :sortable="true">
          <template #body="slotProps">
            <div class="flex align-items-center">
                <RadioButton v-model="slotProps.data.consolidationStatut" inputId="statut1" value="1047" />
                <label for="statut1" class="ml-2">Non reçu</label>
            </div>
            <div class="flex align-items-center">
                <RadioButton v-model="slotProps.data.consolidationStatut" inputId="statut2" value="1048" />
                <label for="statut2" class="ml-2">Reçu</label>
            </div>
            <div class="flex align-items-center">
                <RadioButton v-model="slotProps.data.consolidationStatut" inputId="statut3" value="1049" />
                <label for="statut3" class="ml-2">Retenue</label>
            </div>
          </template>
        </Column>
        <Column field="consoliderLe" header="Date consolidation" :sortable="true"></Column>
      </DataTable>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from 'vuex';

export default {
  name: "FormulaireBillet",
  data() {
    return {
      billets: [],
      nomVague : null,
      isSauvegardeEnCours : false,
    }
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Formulaire Billet");
    this.nomVague = this.dossier.numeroDossier;
    this.$store.dispatch('clientMystere/obtenirBilletsDossiersManquementAction', {
      cle: this.$route.params.cle,
      site: this.$route.params.site
    }).then((res) => {
        res.data.forEach((currentBillet) => {
          currentBillet.consolidationStatut = currentBillet.consolidationStatut + '';
        });
      this.billets = res.data
    })
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      dossier: 'dossier/dossier'
    })
  },
  methods : {
    sauvegarder() {
      this.isSauvegardeEnCours = true;
      this.$store.dispatch('clientMystere/sauvegarderStatutsBilletsAction', this.billets).then(() => {
        this.isSauvegardeEnCours = false;
      })
      
    },
    imprimer() {
        this.$store.dispatch("rapports/gererRapportAction", {
            cle: this.dossier.cle,
            site: this.dossier.site,
            rapport: "CDX_0295",
            langue: "FR",
        });
    },
    annuler() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
}
</script>
